import { normalizeSvgIcon } from "@loot-os/api-contract";
import { useState } from "react";

/**
 * Reads and checks one picked or dropped SVG file with `normalizeSvgIcon` (under `maxBytes`, else
 * its icon default) and hands the normalized source to `onPick`, or holds why it was refused in
 * `error`. The check is for instant feedback; the mutation that saves the SVG is the authority.
 */
export function useSvgFilePick({
  maxBytes,
  onPick,
}: {
  maxBytes?: number;
  onPick: (svg: string) => void;
}) {
  const [error, setError] = useState<string | null>(null);

  const pick = async (file: File | undefined) => {
    setError(null);
    if (!file) return;
    if (file.type && file.type !== "image/svg+xml") {
      setError("That file isn't an SVG.");
      return;
    }
    const result = normalizeSvgIcon(await file.text(), { maxBytes });
    if (!result.ok) {
      setError(result.reason);
      return;
    }
    if (result.svg === "") {
      setError("That file is empty.");
      return;
    }
    onPick(result.svg);
  };

  return { pick, error, clearError: () => setError(null) };
}
